import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-table-expandable', 'expandRow', 'Išskleisti eilutę');
Labels.set('ui-table-expandable', 'collapseRow', 'Sutraukti eilutę');
Labels.set('ui-table-expandable', 'actions', 'Veiksmai');
